import { useState } from "react";

import { FiMail } from 'react-icons/fi';
import { MdOutlineCancel } from 'react-icons/md';
import { handleData } from "../../api";



const AdminBevestigdeTaak = (props) => {

    const {taak, loadingData, verwijderBevestiging} = props;
    const { taakID, activiteitDatum, activiteitNaam, taakNaam, dagdeel, activiteitID, vrijwilliger, vrijwilligerEmail, aanvangstijd= '', vrijwilligersInfo='', vrijwilligerOpmerking='' } = taak;

    const initialInput = {
        time: aanvangstijd,
        info: vrijwilligersInfo
    }

    const [editTime, setEditTime] = useState(false);
    const [editInfo, setEditInfo] = useState(false);
    const [dataInput, setDataInput] = useState(initialInput);

    const handleEditTime = () => {
        setEditTime(!editTime) 
    }

    const handleEditInfo = () => {
        setEditInfo(!editInfo) 
    }

    const handleChange = (e) => {
        setDataInput({
            ...dataInput,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = async () => {
        const path = `activiteiten/${activiteitID}/taken/${taakID}`
        const input = {
            'taken.$.aanvangstijd': dataInput.time,
            'taken.$.vrijwilligersInfo': dataInput.info
        }
        const data = {
            method: 'PATCH',
            path: path,
            input: input

        }
        const editedTaak = await handleData(data);
        setEditTime(false)
        setEditInfo(false)
        loadingData()
    }

    return (
        <>
            <tr>
                <td>{activiteitDatum}</td>
                <td>{activiteitNaam}</td>
                <td>{taakNaam}</td>
                <td>{dagdeel}</td>
                <td>{vrijwilliger} {vrijwilligerOpmerking && "(opmerking)"}</td>
                <td>
                    <a className="contact" href={`mailto:${vrijwilligerEmail}?subject= Brinkruiters - vrijwilligersactiviteit`} target="_blank">
                        <span><FiMail /></span>
                    </a>

                </td>
                <td>
                    <button className="verwijder" onClick={() => verwijderBevestiging(taakID, activiteitID)}>
                        <span><MdOutlineCancel /></span>
                    </button>
                </td>
                <td>
                    {editTime ? 
                        <input 
                            type="text"
                            name="time"
                            id="time"
                            onChange={handleChange}
                            value={dataInput.time}
                        /> : 
                        aanvangstijd
                    }
                </td>
                <td>
                    <button onClick ={handleEditTime}>+</button>
                </td>
                <td>
                {editInfo ? 
                        <input 
                            type="text"
                            name="info"
                            id="info"
                            onChange={handleChange}
                            value={dataInput.info}


                        /> : 
                        vrijwilligersInfo
                    }

                </td>
                <td>
                    <button onClick={handleEditInfo}>+</button>
                </td>
                <td>
                    <button onClick={handleSubmit}>Submit</button>
                </td>
                
            </tr>
            { vrijwilligerOpmerking &&
                <tr>
                    <td></td>
                    <td colSpan="10">{`${vrijwilliger}: "${vrijwilligerOpmerking}"`}</td>
                </tr>
            }


        </>
    );
}

export default AdminBevestigdeTaak;